
var currency = {
    symbol: '$',
    currency: 'USD',
};


function initializeTabs() {
    const tabButtons = document.querySelectorAll('.tabs-buttons a');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabButtons.length === 0 || tabContents.length === 0) {
        return; // Não há tabs nesta página
    }

    tabButtons.forEach(button => {
        button.addEventListener('click', function () {

            // Remove active class from all buttons
            tabButtons.forEach(btn => btn.classList.remove('active'));
            // Add active class to the clicked button
            this.classList.add('active');

            // Hide all tab contents
            tabContents.forEach(content => content.classList.remove('active'));
            // Show the corresponding tab content
            const tabId = this.getAttribute('data-tab');
            document.querySelector(`.${tabId}`).classList.add('active');
        });
    });

}

var hotelList = [];
var continentList = [];

function handleListSelection(type){
    toggleButton();
    toggleHotelsDisplay(); 
}

function toggleButton(element){

    const gridButton = document.querySelector('.text-button.grid');
    gridButton.classList.toggle('active');

    const listButton = document.querySelector('.text-button.list');
    listButton.classList.toggle('active');

}

function toggleHotelsDisplay(){
    
    const listingContainer = document.querySelector('.listing-container.grid');
    listingContainer.classList.toggle('active');
    $("div.paging").toggle('active');

    const gridContainer = document.querySelector('.listing-container.list');
    gridContainer.classList.toggle('active');

}

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

function getHotelListingContainer(){

    let container;
    
    container = '.listing-container.grid';
    

    return container;
}

function hotelContainerClass(){

    let classname;
     classname = 'column';
    return classname;
}

function isHotelListingPage(){
    return window.location.pathname.toLowerCase().indexOf('/suites')>=0;
}

function isExperienceListingPage(){
    return window.location.pathname.toLowerCase().indexOf('/experiences')>=0;
}

function toggleBookMarkFromId(id,recordId,type = 'suite'){
    var btn = document.getElementById(id);
    if(btn){
        toggleBookMark(btn,recordId,type);
    }
    return
}

function toggleBookMark(bkm,recordId,type = 'suite'){
    let method = "PUT"
    if(bkm.classList.contains("active"))
    {
        method = "DELETE"
    }

    var isExp = type == 'exp' || type == 'experience';
    var url = `/api/MySuites${isExp ? '/experience':''}/${recordId}`;

    $.ajax({
        url: url, // Replace with the correct endpoint
        method: method,
        success: function (response) 
        {
            var selectId = isExp ? 'data-experience-id' : 'data-id';
            var allElements = document.querySelectorAll(`[${selectId}="${recordId}"]`);
            allElements.forEach(function (element) {
                element.classList.toggle('active');
            });
        },
        error: function (xhr, status, error) {
            console.log("Failed to bookmark.", error);
        }
    });
    return
}

function generateHotelRoomImageMarkup(hotel){
    let imageHtml = "";

    let hotelImages = hotel.images;
    let roomImages = hotel.room.images;

    if(roomImages && roomImages.length > 0){
        roomImages.forEach((url, index) => {
            imageHtml += `<li class="splide__slide"><img data-splide-lazy="${url.transformedUrl}" alt="Room Image"></li>`;
          });
    }

    if(hotelImages && hotelImages.length > 0){
        hotelImages.forEach((url, index) => {
            imageHtml += `<li class="splide__slide"><img data-splide-lazy="${url.transformedUrl}" alt="Hotel Image"></li>`;
          });
    }

    return imageHtml;
}

function generateExperienceImageMarkup(experience){
    let imageHtml = "";

    if(experience.images && experience.images.length > 0){
        experience.images.forEach((url, index) => {
            imageHtml += `<li class="splide__slide"><img src="${url}" alt="Experience Image"></li>`;
          });
    }

    return imageHtml;
}

function generateExperienceFeaturesMarkup(experience){
    let featureHtml = "";

    if(experience.features && experience.features.length > 0)
    {
        featureHtml += `<div class="info-list"><ul>`;
        experience.features.forEach((feature, index) => 
        {
            featureHtml += `<li class="icon-text"><img width="30px" src=${feature.imageUrl} />${feature.featureName}</li>`;
        });
        featureHtml += `</ul></div>`;
    }

    return featureHtml;
}

function mountHotelContainer(hotel,index,componentType){

    let hideAllSuites = false;
    if(typeof hotelSlug != 'undefined' && hotelSlug){
        hideAllSuites = true;
    }
    let componentToMount = '';
    if  (componentType === 'list') {
        componentToMount = `<li class="hotel-list">
                                <div class="hotel-container">
                                    <div class="top-text left-icon">${hotel.shortAddress}</div>
                                    <div class="main-text left-icon">${hotel.roomName}</div>
                                    <div class="bottom-text">${hotel.hotelName}</div>
                                </div>
                           </li>`
    }
   
    if (componentType === 'grid') 
    {
        let imageHtml = generateHotelRoomImageMarkup(hotel);
        let bedString = hotel.room.numOfRoomString || hotel.room.bedTypesString;
        componentToMount = `<div class="hotel-container ${hotelContainerClass()} ${index % 2 === 0 ? 'reversed' : ''} animate-on-scroll">
            <div class="img-container slider">
                <div class="splide normal">
                    <div class="splide__track">
                        <ul class="splide__list">
                                    ${imageHtml}
                         </ul>
                        </div>
                        </div>
                </div>
                <div class="hotel-infos">
                    <div class="wrapper">
                        <div data-hotel-id="${hotel.hotelId}" data-id=${hotel.id} onclick="toggleBookMark(this,'${hotel.id}')" class="book-marker ${hotel.saved ? "active" : ""}"></div>
                        <div class="location"><a href="${hotel.url}">${hotel.shortAddress}</a></div>
                        <div class="name"><a href="${hotel.url}">${hotel.room.name}</a></div>
                        <div class="subtitle">${hotel.name}</div>
                        <div class="info-list">
                        <ul class="room-info">
                            ${hotel.room.squareMeters > 0 ? '<li class="icon-text sqm">'+hotel.room.squareMeters+' sqm</li>' : ''}
                            ${bedString !== '' ? '<li class="icon-text qtd">'+bedString+'</li>' : ''}
                        </ul>
                        </div>
                        <div class="button-wrapper item-price">
                            <span>${hotel.room.priceString || ''}</span>
                        </div>
                        <div class="button-wrapper">
                            ${hotel.multiple && !hideAllSuites ? ' <a class="btn outline" href="'+hotel.listingUrl+'">VIEW ALL SUITES</a>' : ''}
                            <a class="js-reserve-navigation btn btn-primary explore" href="${hotel.url}">RESERVE</a>
                        </div>
                    </div>
                </div>
            </div>`
    }

    return componentToMount;
}

function mountExperienceContainer(experience,index,componentType)
{
    let componentToMount = '';
    if  (componentType === 'list') {
        componentToMount = `<li class="hotel-list">
                                <div class="hotel-container experience-container">
                                    <div class="top-text left-icon">${experience.city}, ${experience.country}</div>
                                    <div class="main-text left-icon">${experience.name}</div>
                                    <div class="bottom-text">${experience.subTitle}</div>
                                </div>
                           </li>`
    }
    
    if (componentType === 'grid') 
    {
        let imageHtml = generateExperienceImageMarkup(experience);
        let featureHtml = generateExperienceFeaturesMarkup(experience);
        componentToMount = `<div class="hotel-container experience-container ${hotelContainerClass()} ${index % 2 === 0 ? 'reversed' : ''} animate-on-scroll">
                <div class="img-container slider">
                <div class="splide normal">
                    <div class="splide__track">
                        <ul class="splide__list">
                                    ${imageHtml}
                        </ul>
                        </div>
                        </div>
                </div>
                <div class="hotel-infos">
                    <div class="wrapper">
                        <div data-experience-id="${experience.id}" onclick="toggleBookMark(this,'${experience.id}','experience')" class="book-marker ${experience.saved ? "active" : ""}"></div>
                        <div class="location"><a href="${experience.detailsUrl}">${experience.city}, ${experience.country}</a></div>
                        <div class="name experience-name"><a href="${experience.detailsUrl}">${experience.name}</a></div>
                        <div class="subtitle">${experience.subTitle}</div>
                        ${featureHtml}
                        <div class="button-wrapper">
                            <a class="js-reserve-navigation btn btn-primary explore" href="${experience.detailsUrl}">EXPLORE</a>
                        </div>
                    </div>
                </div>
            </div>`
    }

    return componentToMount;
}

function toggleRoomSpinner(hide)
{
    toggleItem(".js-spinner-rooms",hide);
}


function loadPagedHotels(pagedData, emptyContainer = true)
{
    toggleRoomSpinner(true);
    let hotelListContainer = $(getHotelListingContainer());
    if(emptyContainer){
        hotelListContainer.empty();
        window.hotelList = [];
    }
    $(hotelListContainer).removeAttr('style');
    
    pagedData.items.forEach((hotel, index) => {
        let hotelContainer = document.createElement('div');
        hotelContainer.innerHTML = mountHotelContainer(hotel, index, 'grid');
        $(hotelListContainer).append(hotelContainer);
    }); 
    if(pagedData.continuationToken || pagedData.hasMoreResults){
        $(".js-view-more").show();
        setPagingValue(parseInt($(".js-page-val").val()) + 1)
        $(".js-continuation-token").val(pagedData.continuationToken);
    }else{
        setPagingValue(0);
        $(".js-view-more").hide();
    }

    setupTileSliders();
}

function loadPagedExperiences(pagedData, emptyContainer = true)
{
    toggleRoomSpinner(true);
    let hotelListContainer = $(getHotelListingContainer());
    if(emptyContainer){
        hotelListContainer.empty();
        window.hotelList = [];
    }
    $(hotelListContainer).removeAttr('style');
    
    pagedData.items.forEach((experience, index) => {
        let hotelContainer = document.createElement('div');
        hotelContainer.innerHTML = mountExperienceContainer(experience, index, 'grid');
        $(hotelListContainer).append(hotelContainer);
    });

    setupTileSliders();

    if(pagedData.continuationToken || pagedData.hasMoreResults){
        $(".js-view-more").show();
        setPagingValue(parseInt($(".js-page-val").val()) + 1)
        $(".js-continuation-token").val(pagedData.continuationToken);
    }else{
        setPagingValue(0);
        $(".js-view-more").hide();
    }
}

function setPagingValue(val){
    $(".js-page-val").val(val);
}



function loadHotels(hotels) 
{
    let hotelListContainer = $(getHotelListingContainer());
    hotelListContainer.empty();
    $(hotelListContainer).removeAttr('style');
    
    hotels.forEach((hotel, index) => {
        let hotelContainer = document.createElement('div');
        hotelContainer.innerHTML = mountHotelContainer(hotel, index, 'grid');
        $(hotelListContainer).append(hotelContainer);
    });      

    setupTileSliders();
}

function loadExperiences(experiences) 
{
    let hotelListContainer = $(getHotelListingContainer());
    hotelListContainer.empty();
    $(hotelListContainer).removeAttr('style');
    
    experiences.forEach((hotel, index) => {
        let hotelContainer = document.createElement('div');
        hotelContainer.innerHTML = mountExperienceContainer(hotel, index, 'grid');
        $(hotelListContainer).append(hotelContainer);
    });    
    
    setupTileSliders();
}

function exists(obj){
    return typeof obj !== 'undefined' && obj !== null && obj !== '';
}

function hideHotelListsIfApplicable()
{
    let hotelListContainer = getHotelListingContainer();
    toggleRoomSpinner(false);
    toggleItem(hotelListContainer,true);
    toggleItem(".listing-container.list",true);
}

function toggleItem(element, hide){

    var element = $(element);
    if(element){
        if(hide){
            element.hide();
        }
        else{
            element.show();
        }
    }
}



function toggleMenu(){

    const menu = document.querySelector('.nav-menu');
    menu.classList.toggle('active');

}

function toggleLoginPopUp(){
    
    const loginPopup = document.getElementById('registerModal');
    loginPopup.classList.toggle('active');
        
}

function loadHotelContinentListings(listHotels) {

    /*if (window.hotelList && window.hotelList.length == 0) {//hide hotel containers if empty list
        $('#listing-container').addClass('hidden');
    } else {
        $('#listing-container').removeClass('hidden');
    }*/

    $('#countryContainer').removeClass('show');
    $('#hotelListContainer').removeClass('show');

    const continentList = [...new Set(listHotels.map(hotel => hotel.continent))].sort();
    renderContinentList(continentList,listHotels);

    $(".listing-container.list").removeAttr('style');
}


function clearList(id){
        
    const listElement = $(id);
    if(listElement)
    {
        listElement.empty(); 
    }
}

function renderContinentList(continentList, listHotels){

    const continentContainer = $('#continentContainer');
    clearList('#continentContainer');

    continentContainer.addClass('show');

    continentList.forEach(name => {

        const filteredList = listHotels.filter(hotel => hotel.continent == name);
        const continentElement = $('<li></li>').text(`${name}`).append(`<span>${filteredList.length}</span>`);
        continentElement.on('click', function() {
            renderCountryList(name,listHotels);
        });
        continentContainer.append(continentElement);
    });

}

function renderCountryList(continentName,listHotels){

    const countryListElement = $('#countryContainer');
    const filteredList = listHotels.filter(hotel => hotel.continent == continentName);
    countryListElement.addClass('show');
    clearList('#countryContainer');
    clearList('#hotelListContainer');   

    const countryList = [...new Set(filteredList.map(hotel => hotel.country))].sort();

    countryList.forEach(name => {
        let filteredHotels = filteredList.filter(hotel => hotel.country == name)
        const countryElement = $('<li></li>').text(`${name}`).append(`<span>${filteredHotels.length}</span>`);
        countryElement.on('click', function () {
            renderHotelList(name,listHotels);
        });
        countryListElement.append(countryElement);
    })

}

function renderHotelList(country,listHotels) {

    const hotelListContainer = $('#hotelListContainer');
    clearList('#hotelListContainer');
    hotelListContainer.addClass('show');

    const hotels = listHotels.filter(hotel => hotel.country === country);    

    hotels.forEach((hotel,index) => {
        const hotelElement = document.createElement('div');
        hotelElement.innerHTML = mountHotelContainer(hotel,index,'list');

        $(hotelElement).on('click', function() {
            window.location.href = window.location.origin + hotel.url;
        })

        hotelListContainer.append(hotelElement);       
    });
}

function getMysuites() {
    $.ajax({
        url: window.location.origin + '/api/MySuites',
        method: 'GET',
        success: function (data) {
            //console.log("My suites data >", data);
        },
        error: function (error) {
            console.error('Error fetching my suites data:', error);
        }
    });
}

function getMapHotels(){
    $("#google-map").empty();
    $(".js-spinner-map").show();
    var filters = getSearchFilters();
    $.ajax({
        url: window.location.origin + '/api/hotel/map?filter='+ filters.generalSearch,
        method: 'GET',
        contentType: 'application/json'
    })
    .done(function (data) 
    {
        initMap(data);
    })
    .fail(function(jqXHR, textStatus,errorThrown)
    {
        console.error("Error occurred:", textStatus, errorThrown);
    })
}

function getMapExperiences(){
    $("#google-map").empty();
    $(".js-spinner-map").show();
    var filters = getExperienceSearchFilters();
    $.ajax({
        url: window.location.origin + '/api/experience/map?filter='+ filters.generalSearch,
        method: 'GET',
        contentType: 'application/json'
    })
    .done(function (data) 
    {
        initExperienceMap(data);
    })
    .fail(function(jqXHR, textStatus,errorThrown)
    {
        console.error("Error occurred:", textStatus, errorThrown);
    })
}

function getFeaturedHotels(){
    toggleFeaturedItems(true);
    let searchData = getSearchFilters();
    hideHotelListsIfApplicable()
    $.ajax({
        url: window.location.origin + '/api/hotel/featured',
        data: JSON.stringify(searchData),
        method: 'POST',
        contentType: 'application/json'
    })
        .done(function (data) 
        {
            loadHotels(data);
            toggleFeaturedItems(false);
        })
        .fail(function(jqXHR, textStatus,errorThrown)
        {
            console.error("Error occurred:", textStatus, errorThrown);
        })
        .always(function(){
            toggleRoomSpinner(true);
        })
}

function getFeaturedExperiences(){
    toggleFeaturedItems(true);
    hideHotelListsIfApplicable()
    $.ajax({
        url: window.location.origin + '/api/experience/featured',
        method: 'GET',
        contentType: 'application/json'
    })
        .done(function (data) 
        {
            loadExperiences(data);
            toggleFeaturedItems(false);
        })
        .fail(function(jqXHR, textStatus,errorThrown)
        {
            console.error("Error occurred:", textStatus, errorThrown);
        })
        .always(function(){
            toggleRoomSpinner(true);
        })
}

function toggleFeaturedItems(loading){
    if(loading){
        if($("#featured-cont-btn"))
        {
            $("#featured-cont-btn").hide();
        }
        $(".js-spinner-featured-hotels").show();
    }
    else{
        if($("#featured-cont-btn"))
        {
            $("#featured-cont-btn").show();
        }
        $(".js-spinner-featured-hotels").hide();
    }
}

function viewMoreSuites(){
    $(".js-view-more").hide();
    let searchData = getSearchFilters();
    searchData.continuationToken = $(".js-continuation-token").val() || '';
    if($(".js-sp") && $(".js-sp").val() == 'false')
    {
        searchData.ignorePricing = true;
    }

    //initial list is random so we need to exclude those ids
    if(searchData.orderById <= 0)
    {
        var dataList =$(".hotel-container .wrapper").children('.book-marker').map(function() {
            return $(this).data("id").toString();
        }).get();
        searchData.excludeIds = dataList;
    }

    searchData.page = parseInt($(".js-page-val").val()) || 0;

    toggleRoomSpinner(false);
    getHotels(searchData)
    .done(function (data) 
    {
        loadPagedHotels(data,false);
        $(".js-back-filters").show();
    })
    .fail(function(jqXHR, textStatus,errorThrown)
    {
        console.error("Error occurred:", textStatus, errorThrown);
        toggleRoomSpinner(true);
    })
}

function viewMoreExperiences(){
    $(".js-view-more").hide();
    let searchData = getExperienceSearchFilters();
    searchData.continuationToken = $(".js-continuation-token").val() || '';
    //initial list is random so we need to exclude those ids
    if(searchData.orderById <= 0)
    {
        var dataList =$(".hotel-container .wrapper").children('.book-marker').map(function() {
            return $(this).data("experience-id").toString();
        }).get();
        searchData.excludeIds = dataList;
    }

    toggleRoomSpinner(false);
    getExperiences(searchData)
    .done(function (data) 
    {
        loadPagedExperiences(data,false);
        $(".js-back-filters").show();
    })
    .fail(function(jqXHR, textStatus,errorThrown)
    {
        console.error("Error occurred:", textStatus, errorThrown);
        toggleRoomSpinner(true);
    })
}

function getAllHotelAndSuites(initial = false)
{
    $(".js-view-more").hide();
    $(".js-no-suites").hide();
    $(".js-back-filters").hide();
    setPagingValue(0);
    let searchData = getSearchFilters();
    if(ghip != undefined && initial)
    {
        searchData.ignorePricing = !ghip;
        if($(".js-sp")){
            $(".js-sp").val(ghip);
        }
    }
    else if($(".js-sp")){
        $(".js-sp").val(true);
    }
    hideHotelListsIfApplicable();
    $(".js-continuation-token").val('');

    var gridHotels = getHotels(searchData);
    var listHotels = getListHotels(searchData);

    $.when(gridHotels, listHotels).done(function (gridHotelRes, listHotelRes) 
    {
        if(gridHotelRes[0].items.length == 0){
            $(".js-no-suites").show();
        }
        else{
            $(".js-no-suites").hide();
        }
        loadPagedHotels(gridHotelRes[0]);
        loadHotelContinentListings(listHotelRes[0]);
    })
    .fail(function(jqXHR, textStatus,errorThrown)
    {
        console.error("Error occurred:", textStatus, errorThrown);
        toggleRoomSpinner(true);
    })
}

function getAllExperiences(){
    $(".js-view-more").hide();
    $(".js-no-suites").hide();
    $(".js-back-filters").hide();
    setPagingValue(0);
    let searchData = getExperienceSearchFilters();
    hideHotelListsIfApplicable();
    $(".js-continuation-token").val('');
    getExperiences(searchData)
    .done(function (data) 
    {
        if(data.items.length == 0){
            $(".js-no-suites").show();
        }
        else{
            $(".js-no-suites").hide();
        }
        loadPagedExperiences(data);
    })
    .fail(function(jqXHR, textStatus,errorThrown)
    {
        console.error("Error occurred:", textStatus, errorThrown);
        toggleRoomSpinner(true);
    })
}

function getHotels(searchData){
    return $.ajax({
        url: window.location.origin + '/api/hotel',
        data: JSON.stringify(searchData),
        method: 'POST',
        contentType: 'application/json'
    });
}

function getListHotels(searchData){
    return $.ajax({
        url: window.location.origin + '/api/hotel/list',
        data: JSON.stringify(searchData),
        method: 'POST',
        contentType: 'application/json'
    });
}

function getExperiences(searchData){
    return $.ajax({
        url: window.location.origin + '/api/experience',
        data: JSON.stringify(searchData),
        method: 'POST',
        contentType: 'application/json'
    });
}

function getExperienceSearchFilters() {
    let filter = {};
    const generalSearch = $("#js-srch-experiences").val() || '';
    const bookingDate = getExperienceFlatpickrOrDefaultBookingDate(); 
    const priceMin =  getPriceMin();
    const priceMax = getPriceMax();
    const adultsMin = $('#adults-min').val() || $('#guests-adults').val(); 
    const childMin = $('#child-min').val() || $('#guests-children').val();
    const orderBy = $("#hotel-order-by").val();
    const typeIds = getMultiSelectedValues("#experience-type-list");
    const location = getMultiSelectedValues("#experience-location-list");

    filter = {
        generalSearch: generalSearch,
        bookingDate,
        priceMin,
        priceMax,
        adultsMin,
        childMin,
        orderById : parseInt(orderBy ?? 0),
        ExperienceTypeIds : typeIds,
        locations: location
    };   

    return filter;
}

function getSearchFilters() {

    let filter = {};
    const brand = getBrandFromSelect() || '';
    let generalSearch = $("#js-srch-hotels").val() || '';

    let bookingDates = getFlatpickrOrDefaultBookingDates();

    let checkInDate = bookingDates.checkInDate;
    let checkOutDate = bookingDates.checkOutDate;
    const squareMetersMin = $('#min-sqm-range').val();
    const squareMetersMax = $('#max-sqm-range').val();
    const bedrooms = parseInt($('#bedrooms').val()) || 0;
    const priceMin =  getPriceMin();
    const priceMax = getPriceMax();
    const adultsMin = $('#adults-min').val() || $('#guests-adults').val(); 
    const childMin = $('#child-min').val() || $('#guests-children').val();
    const orderBy = $("#hotel-order-by").val();
    const popFilters = getPopularFilters();
    let hotelSlugFilter = '';
    if(typeof hotelSlug != 'undefined' && hotelSlug){
        hotelSlugFilter = hotelSlug;
        generalSearch = '';
    }
    else{
        var hoteldrop = $("#hotel-list");
        if(hoteldrop.length > 0){
            hotelSlugFilter = hoteldrop.val();
        }
    }
   

    if (!checkInDate || !checkOutDate)
        return showNotification('Please, select check-in and check-out date.');

    filter = {
        generalSearch: generalSearch,
        brand: brand,
        checkInDate,
        checkOutDate,
        squareMetersMin,
        squareMetersMax,
        priceMin,
        priceMax,
        adultsMin: adultsMin,
        childMin: childMin,
        orderById : parseInt(orderBy ?? 0),
        popularFilters : popFilters,
        bedrooms: bedrooms,
        hotelSlug: hotelSlugFilter
    };   

    return filter;

}

function getBrandFromSelect() {

    const brands = document.querySelectorAll('.brand-checkbox');

    if (!brands || brands.length == 0)
        return "";

    const selectedBrand = Array.from(brands).find(brand => brand.checked);

    if (!selectedBrand || !selectedBrand.value)
        return "";

    return selectedBrand.value;   

}

function renderMsg(elementId, msg, msgStyle) {
    const msgContainer = $(`<div class=${msgStyle}>${msg}</div>`);
    clearMsg(elementId);
    $(elementId).append(msgContainer);
}

function clearMsg(elementId) {
    $(elementId).empty();
}

function setStorageItem(name, data) {

  localStorage.setItem(name, JSON.stringify(data));

}

function getStorageItem(name) {
    const item = localStorage.getItem(name);
    try {
        return item ? JSON.parse(item) : null;
    } catch (error) {
        return "";
    }
}

function removeStorageItem(name) {
    localStorage.removeItem(name);
}

function showHotelByCountry(country) {

    const hotels = hotelList.filter(hotel => hotel.country === country);
    clearHotelList();


}

function decrement(fieldId, minValue = 0){

    const field = document.getElementById(fieldId);
    let value = parseInt(field.value);

    if(value > minValue)
    {
        field.value = value - 1;
    }

}

function increment(fieldId, maxValue = 10){

    const field = document.getElementById(fieldId);
    let value = parseInt(field.value);

    if(value == maxValue){
        return;
    }

    field.value = value + 1;

}

function toggleFilterContainer(){

    const filterContainer = document.querySelector('.filter-component');
    filterContainer.classList.toggle('active');

}


function closeFilterContainer(){

    const filterContainer = document.querySelector('.filter-component');
    filterContainer.classList.remove('active');

}

function getFaqQuestions(){

    // $.ajax({
    //     url: window.location.origin + '/api/faq',
    //     method: 'GET',
    //     success: function(data) {
    //         renderFaqQuestions(data);
    //     },
    //     error: function(error) {
    //         console.error('Error fetching faq data:', error);
    //     }
    // });

    const data = [
        {question:'What is SuiteClub?', answer:'SuiteClub is a luxury hotel booking platform that offers a wide range of luxury suites and bedrooms in the most exclusive hotels around the world.'},
        {question:'How can I book a bedroom?', answer:'You can book a bedroom by clicking on the "RESERVE" button on the hotel page. You will be redirected to the hotel booking page where you can complete your reservation.'},
        {question:'How can I cancel my reservation?', answer:'You can cancel your reservation by contacting the hotel directly. Please note that the hotel\'s cancellation policy will apply.'},
        {question:'How can I contact Suite Collection?', answer:'You can contact SuiteClub by sending an email to ...'},
    ];

    const faqContainer = document.querySelector('.full-width-list.faq');
    
    data.forEach((item,index) => {

        const faqElement = document.createElement('li')
        faqElement.setAttribute('class','dark-li expansive-li');
        faqElement.innerHTML = `<div class="li-item">
                                    <div id="expand-action" class="left-brand-icon full-right-icon">${item.question}</div>
                                    <div class="expansive-container expansive-container--horizontal">
                                        <p><div>${item.answer}</div></p>
                                    </div>
                                </div>`;

        setUpFAQExpansivePanel(faqElement);
        faqContainer.appendChild(faqElement);

    });

};

function setUpFAQExpansivePanel(item){

    item.addEventListener('click', function () {

        item.classList.toggle('active');
        const expansive = this.querySelector(".expansive-container");

        if (expansive.style.maxHeight) {
            expansive.style.maxHeight = null;
        } else {
            expansive.style.maxHeight = expansive.scrollHeight + "px";
        } 

    });
        
}

function initSlider(_class, options){
    var splide = new Splide( _class, options );

    if(options.progressBarClass){

        var bar = splide.root.querySelector(options.progressBarClass);

        splide.on( 'mounted move', function () {
            var end  = splide.Components.Controller.getEnd() + 1;
            var rate = Math.min( ( splide.index + 1 ) / end, 1 );
            bar.style.width = String( 100 * rate ) + '%';
        } );
        
    }

    

    splide.on('mounted', function () {
        if(options.skeletonId){
            const splideEl = document.querySelector(_class);
            const skeleton = document.querySelector(options.skeletonId);
            skeleton.style.display = 'none';
            // show slider
            splideEl.classList.add('is-ready');
        }

        // preload first slide immediately
        const firstSlide = splide.Components.Slides.getAt(0)?.slide;
        loadVideo(firstSlide);
    });

    if(options.thumbnailId){
        var thumbnails = new Splide( options.thumbnailId, options.thumbnailOptions );
        
        splide.sync( thumbnails );
    }

     splide.on('active', function (slide) {
        // load current slide video
        loadVideo(slide.slide);

        // pre-load next slide (smooth UX)
        const next = splide.Components.Slides.getAt(slide.index + 1);
        if (next) {
            loadVideo(next.slide);
        }
    });

    splide.mount();

    if(options.thumbnailId)
    thumbnails.mount();

}

 function loadVideo(slide) {
        if (!slide) return;

        const video = slide.querySelector('video');
        if (!video) return;

        // already loaded
        if (video.dataset.loaded === "true") return;

        const src = video.getAttribute('data-src');
        if (!src) return;

        video.src = src;
        video.load();

        video.dataset.loaded = "true";

        video.addEventListener('canplay', () => {
            video.classList.add('is-ready');
        }, { once: true });
    }

function initExpansivePanel(panel,addInfo) {
    const accordion_container = document.getElementById(panel);
    if (!accordion_container) return;
    const expansive_panel = accordion_container.querySelector(".expansive-container");
    const accordionTitle = accordion_container.querySelector(".accordion-title"); 

    function openExpansivePanel() {
        const openHeight = (expansive_panel.scrollHeight || 500) + "px";
        if (expansive_panel.style.maxHeight !== openHeight) {
            expansive_panel.style.maxHeight = openHeight;
        }
    }

    if (addInfo && addInfo.openOnStart) {
        openExpansivePanel();

        const start_arrow_button = accordionTitle.querySelector(".icon");
        if (start_arrow_button) {
            start_arrow_button.classList.add('active');
        }
    }

    if (typeof ResizeObserver === "function") {
        const contentObserver = new ResizeObserver(function () {
            if (expansive_panel.style.maxHeight) {
                openExpansivePanel();
            }
        });

        Array.prototype.forEach.call(expansive_panel.children, function (child) {
            contentObserver.observe(child);
        });
    }

    accordionTitle.addEventListener('click', function () {
        const arrow_button = this.querySelector(".icon");

        if (expansive_panel.style.maxHeight) {
            expansive_panel.style.maxHeight = null;
        } else {
            openExpansivePanel();
        } 

        if (arrow_button) {
            arrow_button.classList.toggle('active'); 
        }
    });

}

function initializeRangeSlider(sliderId,sliderRangeOptions){    

    $(sliderId).slider({
        range: sliderRangeOptions.range,
        min: sliderRangeOptions.min ? sliderRangeOptions.min : 0,
        max: sliderRangeOptions.max ? sliderRangeOptions.max : 25000,
        values: sliderRangeOptions.values,
        slide: function( event, ui ) {

            switch (sliderRangeOptions.type) {
                case 'price':
                    $( sliderRangeOptions.minInputId ).val(ui.values[ 0 ]);
                    $( sliderRangeOptions.maxInputId ).val(ui.values[ 1 ]);
                    break

                case 'sqm':
                    $(sliderRangeOptions.minInputId).val(ui.values[0]);
                    $(sliderRangeOptions.maxInputId).val(ui.values[1]);
                    break
            }


        }
    });
}

    
function initializSindleSlider(sliderId, options){

    $( sliderId ).slider({
        range: "min",
        value: options.initialValue ? options.initialValue : 37,
        min: options.min ? options.min : 0,
        max: options.max,
        slide: function( event, ui ) {
            options.callback(ui.value);
          $( options.inputId ).val( "$" + ui.value );
        }
    });

}

function navigateTo(componentId) {
    const component = document.querySelector(componentId) || document.getElementById(componentId);

    if (component) {
        setTimeout(() => {
            component.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }, 100); // Ajuste o tempo de atraso conforme necessário
    }
}


function navigateToOffset(componentId, offsetAmount = 70){
        const offset = offsetAmount;
        const element = $(document.querySelector(componentId) || document.getElementById(componentId));

        $('html, body').animate({
        scrollTop: element.offset().top - offset
        }, 100); // 500ms animation
}

function changeContainerVisibility(idList) {

    idList.forEach(id => {

        const container = document.querySelector(id);
        container.classList.toggle('active');

    })

}



function displayCurrency(value) {
    return currency['symbol'] + " " + value + " " + currency['currency'];
}

function clearAllFields() {
    resetSliders();
    clearAllCheckboxes();
    clearAllFilterInputs();
    getAndSetListingFilterFields();
    location.reload();
}

function clearAllFilterInputs() {

    setField('#bedrooms', '0');
    setField('#adults-min', '1');
    setField('#child-min', '0');
    setField('#brand-search', '');
    setField('#hotel-list', '');
    setField("#min-price-range", '0');
    setField("#min-sqm-range", '0');
    setField("#min-price-range", '0');
    setField("#max-price-range", '0');

}

function clearAllCheckboxes() {
    var checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
    });
}

function resetSliders() {
    $("#sqm-slider-range").slider("values", [0, 500]);
    $("#price-slider-range").slider("values", [0, 25000]);
}

function filterBrands() {
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById('brand-search');
    filter = input.value.toUpperCase();
    ul = document.getElementById("brand-list");
    li = ul.getElementsByTagName('li');

    for (i = 0; i < li.length; i++) {
        txtValue = li[i].textContent || li[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
        } else {
            li[i].style.display = "none";
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {

    initializeTabs();

    const items = [
        { class: '.hotel-container.sided', animation: 'containerFadeInLeft' },
        { class: '.hotel-container.sided.reversed ', animation: 'containerFadeInRight' },
        { class: '.member-details-container', animation: 'containerFadeInLeft' },
        { class: '.benefits-tab', animation: 'containerFadeInRight' },
        { class: '.text-side', animation: 'containerFadeInDown'}
    ];

    let lastScrollTop = 0;
    function handleScroll() {

        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        items.forEach(item => {
            const elements = document.querySelectorAll(item.class);

            elements.forEach((element, index) => {
                const rect = element.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (rect.top < windowHeight && rect.bottom >= 0) {

                    if (currentScrollTop > lastScrollTop) {
                        element.classList.add(item.animation);
                    }

                } else {
                   //element.classList.remove(item.animation);
                }

            });
        });

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; 

    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on load in case the elements are already in view
});

$(document).ready(function () {

    // Open modal
    $('.open-modal').on('click', function () {
        var target = $(this).data('target');
        $('#modal-error-messages').empty();
        $(target).fadeIn();
    });

    // Close modal when clicking on the close button
    $('.modal').on('click', '.close-modal', function () {
        $(this).closest('.modal').fadeOut();
    });

    // Close modal when clicking outside the modal content
    $(window).on('click', function (event) {
        if ($(event.target).hasClass('modal')) {
            $(event.target).fadeOut();
        }
    });

    
    
    

    $("#search-hotels").on('click', function () {
        saveFilterToLocalStorage();
        saveExperienceItemsToLocalStorage();
        setFilterExpiry(2);

        var url = isSuitesFilterActive() ? "/suites?disc=1" : "/experiences";
        var searchVal = isSuitesFilterActive() ? $("#js-srch-hotels").val() : $("#js-srch-experiences").val();

        if(window.dataLayer == undefined || searchVal == undefined || searchVal == ""){
            window.location.href = url;
            return;
        }

        if(isSuitesFilterActive())
        {
            window.dataLayer.push({
                event: 'site_search',
                search_term: searchVal,
                search_category: 'suites',
            });
        }
        else
        {
            window.dataLayer.push({
            event: 'site_search',
            search_term: searchVal,
            search_category: 'experiences',
            });
        }

        window.location.href = url;

        
    });

    $('#filter-hotels').on('click', function (filters) 
    {
        if(isHotelListingPage()){
            saveFilterToLocalStorage();
            getAllHotelAndSuites();
        }
        else{
            saveExperienceItemsToLocalStorage();
            getAllExperiences();
        }
        
    });
});

function getBookingDatesFromStorageOrDefault(){
    if(!getStorageItem('checkInOutDates'))
    {
        return {
            checkInDate: formatDate(defaultCheckInDate()),
            checkOutDate: formatDate(defaultCheckOutDate())
        };
    }

    let {checkInDate,checkOutDate} = getStorageItem('checkInOutDates');

    var today = formatDate(todayDate());
    var defaultCheckIn = formatDate(defaultCheckInDate());
    var defaultCheckOut = formatDate(defaultCheckOutDate());

    if(checkInDate)
    {
        if(checkInDate < today)
        {
            checkInDate = defaultCheckIn;
        }
    }

    if(checkOutDate)
    {
        if(checkOutDate < today || checkOutDate <= checkInDate)
        {
            checkOutDate = defaultCheckOut;
        }
    }

    return {
        checkInDate: checkInDate ? checkInDate : defaultCheckIn,
        checkOutDate: checkOutDate ? checkOutDate : defaultCheckOut
    };
}

function getExperienceBookingDateOrDefaultFromLocalStorage(){
    var experienceFilter = getExperienceItemsFromLocalStorage();
    var todayDateFormatted = formatDate(todayDate());
    if(!experienceFilter || !experienceFilter.bookingDate){
        return todayDateFormatted;
    }

    if(experienceFilter.bookingDate < todayDateFormatted){
        return todayDateFormatted;
    }

    return experienceFilter.bookingDate;
}

function getStorageAdultsChildren(){
    const adults = getStorageItem('adults') || 1;
    const children = getStorageItem('children') || 0;

    return {
        adults: adults,
        children: children
    };
}

function onInitScroll() {

    const scrollToElementId = getStorageItem('scrollTo');
    navigateTo(scrollToElementId);
    removeStorageItem('scrollTo');

}

function showNotification(message) {
    const notification = $('#notification');
    notification.text(message);
    notification.fadeIn();

    setTimeout(function () {
        notification.fadeOut();
    }, 3000);
}

function formatDate(date) {

    if(!date)
        return;

    var formatDate = new Date(date);

    const year = formatDate.getFullYear();
    const month = String(formatDate.getMonth() + 1).padStart(2, '0');
    const day = String(formatDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}



function getAndSetListingFilterFields() {

    $.ajax({
        url: '/api/hotelfilter',
        type: 'GET',
        contentType: "application/json",
        success: function (data) {
            //setBrandsList(data.brands);
            setHotelsList(data.searchItems.hotelList);
        },
        error: function (error) {
            console.error('Error getting filter:', error);
        }
    });

}

function getAndSetListingExperienceFilterFields() {

    $.ajax({
        url: '/api/experience/filters',
        type: 'GET',
        contentType: "application/json",
        success: function (data) {
            //setBrandsList(data.brands);
            setExperienceLocationsList(data.locationsList);
            setExperienceTypesList(data.experienceTypesList);
        },
        error: function (error) {
            console.error('Error getting filter:', error);
        }
    });

}

function getPriceMax(){
    return $('#max-price-range').val() || 0;
}

function getPriceMin(){
    return $('#min-price-range').val() || 0;
}

function todayDate(){
    return new Date();
}

function nextWeekDate(){
    let today = todayDate();
    let sevenDaysFromToday = todayDate();
    return new Date(sevenDaysFromToday.setDate(today.getDate() + 7));
}

function defaultCheckInDate(){
    let thirtyDaysFromToday = todayDate();
    return new Date(thirtyDaysFromToday.setDate(thirtyDaysFromToday.getDate() + 30));
}

function defaultCheckOutDate(){
    let checkIn = defaultCheckInDate();
    return new Date(checkIn.setDate(checkIn.getDate() + 7));
}

/*function setBrandsList(list) {

    const brandList = list ? list : [];
    const listContainer = $('#brand-list');//ID FROM LISTING PAGE
    listContainer.empty();

    if(list.length == 0){

        $(".brand-title").hide();
        $(".brand-search-input").hide();
        $(listContainer).hide();
        return;
    }



    for (let i = 0; i < brandList.length; i++) {

        const listItem = $(`<li></li>`).text(list[i])
        const checkbox = $(`<input type="checkbox" id="${list[i]}" name="${list[i]}" class="brand-checkbox" value="${list[i]}">`);
        checkbox.on('click', function (event) {
            selectOnChange(list[i]);
        });
        listItem.append(checkbox);
        listContainer.append(listItem);

    }

    $(".brand-title").show();
    $(".brand-search-input").show();
    $("#brand-list").show();
}*/

function setExperienceTypesList(experienceTypes){
    setMultiSelectList(experienceTypes, '#experience-type-list',"experienceType")
}

function setExperienceLocationsList(experienceLocations){
    setMultiSelectList(experienceLocations, '#experience-location-list',"experienceLocation")
}

function setMultiSelectList(list,selector,type) {

    const itemList = list ? list : [];
    const listContainer = $(selector);//ID FROM LISTING PAGE
    listContainer.empty();

    if(list.length == 0)
    {
        $(listContainer).hide();
        return;
    }

    for (let i = 0; i < itemList.length; i++) {

        let id = `${type}_${itemList[i].value}`;
        const listItem = $(`<li></li>`).text(itemList[i].text)
        const checkbox = $(`<input type="checkbox" id="${id}" name="${type}_${itemList[i].value}" class="${type}-checkbox" value="${itemList[i].value}">`);
        checkbox.on('click', function (event) {
            selectOnChange(id,type);
        });
        listItem.append(checkbox);
        listContainer.append(listItem);

    }
    $(selector).show();
}

function filterMultiSelectItems(search,ulSelector) {
    var filter, ul, li, a, i, txtValue;
    filter = search.value.toUpperCase();
    ul = $(ulSelector);
    li = $(ul).children();

    for (i = 0; i < li.length; i++) {
        txtValue = li[i].textContent || li[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
        } else {
            li[i].style.display = "none";
        }
    }
}

function setHotelsList(list) {

    const hotelList = list ? list : [];
    const listContainer = $('#hotel-list');//ID FROM LISTING PAGE
    listContainer.empty();

    if(list.length == 0 || typeof hotelSlug != 'undefined' && hotelSlug){
        $('#hotel-list').hide();
        $('.hotel-list-title').hide();
        return;
    }

    if(list.length == 0){
        const selectListOption = $(`<option value="">All</option>`);
        listContainer.append(selectListOption);
    }

    for (let i = 0; i < hotelList.length; i++) {
        const selectListOption = $(`<option value="${list[i].value}">${list[i].text}</option>`);
        listContainer.append(selectListOption);
    }
} 

function selectOnChange(id,type) {

    var myCheckbox = $(id);
    if(myCheckbox.length > 0){
        if(myCheckbox.is(":checked")){
            $(id).attr("checked", false);
        }
        else{
            $(id).attr("checked", true);
        }
    }
}

function setSquareMetersMax(maxRange) {

    const squareMetersMax = Math.ceil(maxRange ? maxRange : 0);

    setField('#max-sqm-range', squareMetersMax);
    initializeRangeSlider(
        "#sqm-slider-range", {
            range: true,
            type: 'sqm',
            max: squareMetersMax,
            min: 0,
            minInputId: "#min-sqm-range",
            maxInputId: "#max-sqm-range",
            values: [0, 500],
    });

}

function setPriceMaxRange(maxRange) { 

    const priceMax = Math.ceil(maxRange ? maxRange : 0);

    setField('#max-price-range',priceMax);
    initializeRangeSlider(
        "#price-slider-range", {
            range: true,
            type: 'price',
            min: 0,
            max: priceMax,
            minInputId: "#min-price-range",
            maxInputId: "#max-price-range",
            values: [0, priceMax],
    });

}

function setField(fieldId, value) {
    var field = $(fieldId);
    if(field.length <= 0){
        return;
    }

    $(field).val(value);
}

function validateFields(contextOrFields) {
    let errorMessages = [];
    let isValid = true;

    let fields;

    // Verifica se o parâmetro é um contexto (elemento DOM) ou uma lista de IDs de campos
    if (contextOrFields instanceof HTMLElement) {
        fields = contextOrFields.querySelectorAll("[required]");
    } else if (Array.isArray(contextOrFields)) {
        fields = contextOrFields.map(fieldId => document.getElementById(fieldId));
    } else {
        console.error("Invalid parameter passed to validateFields.");
        return false;
    }

    fields.forEach(function (field) {
        const $field = $(field);

        if (!$field.val() || $field.val().trim() === "") {
            isValid = false;
            errorMessages.push(`${$field.attr("data-validation-prop") || $field.attr("name") || field.id || "Field"} is required.`);
            $field.addClass("error-border");
        } else {
            $field.removeClass("error-border");
        }
    });

    // Exibe mensagens de erro, se houver
    const errorContainer = document.getElementById("error-messages") || document.getElementById("guest-error-messages") || contextOrFields?.querySelector("#register-error-messages") || contextOrFields?.querySelector("#primary-member-register-error-messages");
    if (errorMessages.length > 0) {
        $(errorContainer).html(errorMessages.join("<br>"));
        return false;
    } else if (errorContainer) {
        $(errorContainer).empty();
    }

    return isValid;
}

function showPrimaryMemberForm(){
    $("#register-form-cont").hide();
    $("#primary-member-register-cont").show();
    if($(".js-executive-assist-tickbox").prop('checked')){
        $("#primary-member-register-form").show();
    }
    else{
        $("#primary-member-register-form").hide();
    }
}

function showUserRegisterForm(){
    $("#primary-member-register-cont").hide();
    $("#register-form-cont").show();
}


function validateUser(button){
    const $form = $("#user-register-form")[0];

    if (!$form || !validateFields($form))
    {
        return;
    }

    $(button).toggleClass("loading");

    var jsonData = getJsonFieldsFromForm($form,true);

    $.ajax({
        url: '/api/signup/validate',
        type: 'POST',
        contentType: "application/json",
        data:  JSON.stringify({
            ...jsonData
        }),
        success: function () {
            $(button).toggleClass("loading");
          showPrimaryMemberForm();
          navigateTo("register-header")
        },
        error: function (error) {
            if(error.responseJSON && error.responseJSON.errors){
                var msg = 'There was an issue with your registration: ';
                let errorKeys = Object.keys(error.responseJSON.errors);
                let validationErrors = [];
                $(errorKeys).each(function(index, value) {
                    var errorsFromArray = error.responseJSON.errors[value];
                    var formElement = $form.querySelector("#"+value);
                    if(formElement){
                        formElement.classList.add("error-border");
                    }

                    for(var j = 0; j < errorsFromArray.length; j++){
                        if(validationErrors.indexOf(errorsFromArray[j]) < 0)
                        {
                            validationErrors.push(errorsFromArray[j]);
                        }
                    }
                })
                
                for (var i = 0; i < validationErrors.length; i++) {
                    msg += "<br/>" + validationErrors[i];
                }

                $form.querySelector("#register-error-messages").innerHTML = msg;

            }
            else{
                $form.querySelector("#register-error-messages").innerHTML = error.responseText;
            }
            
            $(button).toggleClass("loading");
        }
    });
}

function getJsonFieldsFromForm($form, userForm){

    var formData = {
        title: $form.querySelector("[name='title']").value,
        first_name: $form.querySelector("[name='first_name']").value,
        last_name: $form.querySelector("[name='last_name']").value,
        email: $form.querySelector("[name='email']").value,
        mobile: $form.querySelector("[name='mobile']").value,
        address: $form.querySelector("[name='address']").value,
        city: $form.querySelector("[name='city']").value,
        state: $form.querySelector("[name='state']").value,
        postcode: $form.querySelector("[name='postcode']").value,
        country: $form.querySelector("[name='country']").value,
        currency_code_id: $form.querySelector("[name='currency_code_id']").value,
    }

    if(userForm){
        formData.password = $form.querySelector("[name='password']").value,
        formData.confirm_Password = $form.querySelector("[name='confirm_password']").value,
        formData.is_ea = $form.querySelector("[name='isExecutiveAssistant']").checked
    }

    formData.token = grecaptcha.getResponse();

    return formData;
}

function registerNewUser(button) {
    
    const $form = $("#user-register-form")[0];
    if (!$form || !validateFields($form))
    {
        return;
    }

    var validationForm = $form;
    var userFormData = getJsonFieldsFromForm($form,true);
    if(userFormData.is_ea)
    {
        var primaryMemberForm = $("#primary-member-register-form")[0];
        validationForm = primaryMemberForm;
        if(!primaryMemberForm || !validateFields(primaryMemberForm)){
            return;
        }
        userFormData.primary_member = getJsonFieldsFromForm(primaryMemberForm,false);
    }

    var token = grecaptcha.getResponse();
    userFormData.token = token;

    $(button).toggleClass("loading");

    $.ajax({
        url: '/api/signup',
        type: 'POST',
        contentType: "application/json",
        data: JSON.stringify({
            ...userFormData
        }),
        success: function (data) {
            window.location.href = "/MicrosoftIdentity/Account/SignIn";
            $('#registerModal').fadeOut();
            $(button).toggleClass("loading");
        },
        error: function (error){

            let errorSelector = "#primary-member-register-error-messages";
            let responseErrorSelector = "#primary-member-register-error-response-message";
            document.querySelector(errorSelector).innerHTML = "";
            document.querySelector(responseErrorSelector).innerHTML = "";
            if(error.responseJSON && error.responseJSON.errors)
            {
                var idPrefixSelector = userFormData.is_ea ? "primary-member-" : "";
                var msg = 'There was an issue with your registration: ';
                let errorKeys = Object.keys(error.responseJSON.errors);
                let validationErrors = [];
                $(errorKeys).each(function(index, value) {
                    var errorsFromArray = error.responseJSON.errors[value];
                    if(idPrefixSelector != "")
                    {
                        var formElement = validationForm.querySelector("#"+idPrefixSelector+value);
                        if(formElement){
                            formElement.classList.add("error-border");
                        }
                    }

                    for(var j = 0; j < errorsFromArray.length; j++){
                        if(validationErrors.indexOf(errorsFromArray[j]) < 0)
                        {
                            validationErrors.push(errorsFromArray[j]);
                        }
                    }
                })
                
                for (var i = 0; i < validationErrors.length; i++) {
                    msg += "<br/>" + validationErrors[i];
                }

                document.querySelector(errorSelector).innerHTML = msg;
                navigateTo("#register-header");
                grecaptcha.reset();

            }
            else
            {
                document.querySelector(responseErrorSelector).innerHTML = error.responseText;
                grecaptcha.reset();
            }
            
            $(button).toggleClass("loading");
            console.error('Error registering user:', error.responseText);
        }
    });
}


function invitePrimaryMember(button) {
    
    const $form = $("#primary-member-register-form")[0];
    if (!$form || !validateFields($form))
    {
        return;
    }

    var validationForm = $form;
    var primaryUserFormData = getJsonFieldsFromForm($form,false);

    $(button).toggleClass("loading");

    $.ajax({
        url: '/api/signup/primaryMember',
        type: 'POST',
        contentType: "application/json",
        data: JSON.stringify({
            ...primaryUserFormData
        }),
        success: function (data) {
            $('#primaryMemberRegisterModal').fadeOut();
            if($(".js-update-relationship-form")){
                $(".js-update-relationship-form").hide();
                $(".js-update-relationship-spinner").show();
            }
            window.location.href = window.location.origin + window.location.pathname + "?showRelatedUsersTab=true";
        },
        error: function (error){

            let errorSelector = "#primary-member-register-error-messages";
            let responseErrorSelector = "#primary-member-register-error-response-message";
            document.querySelector(errorSelector).innerHTML = "";
            document.querySelector(responseErrorSelector).innerHTML = "";
            if(error.responseJSON && error.responseJSON.errors)
            {
                var idPrefixSelector = "primary-member-";
                var msg = 'There was an issue with your registration: ';
                let errorKeys = Object.keys(error.responseJSON.errors);
                let validationErrors = [];
                $(errorKeys).each(function(index, value) {
                    var errorsFromArray = error.responseJSON.errors[value];
                    var formElement = validationForm.querySelector("#"+idPrefixSelector+value);
                    if(formElement){
                        formElement.classList.add("error-border");
                    }

                    for(var j = 0; j < errorsFromArray.length; j++){
                        if(validationErrors.indexOf(errorsFromArray[j]) < 0)
                        {
                            validationErrors.push(errorsFromArray[j]);
                        }
                    }
                })
                
                for (var i = 0; i < validationErrors.length; i++) {
                    msg += "<br/>" + validationErrors[i];
                }

                document.querySelector(errorSelector).innerHTML = msg;
                navigateTo("#register-header");
                grecaptcha.reset();

            }
            else
            {
                document.querySelector(responseErrorSelector).innerHTML = error.responseText;
                grecaptcha.reset();
            }
            
            $(button).toggleClass("loading");
            console.error('Error inviting Primary Member:', error.responseText);
        }
    });
}


/*function getFlatpickrOrDefaultCheckInDate(){
    var flatpickrDate = getFormattedDatesFromBookingDatePicker();
    if(!flatpickrDate || !flatpickerDate.checkInDate){
        return getCheckInDate();
    }
    return flatpickrDate.checkInDate;
}

function getFlatpickrOrDefaultCheckOutDate(){
    var flatpickrDate = getFormattedDatesFromBookingDatePicker();
    if(!flatpickrDate || !flatpickerDate.checkOutDate){
        return getCheckOutDate();
    }

    return flatpickrDate.checkOutDate;
}*/


function getFlatpickrOrDefaultBookingDates(){
    var flatpickrDate = getFormattedDatesFromBookingDatePicker();
    if(!flatpickrDate || !flatpickrDate.checkInDate){
        return getBookingDatesFromStorageOrDefault();
    }

    return flatpickrDate;
}

function getExperienceFlatpickrOrDefaultBookingDate(){
    var flatpickrDate = getFormattedDateFromExperienceDatePicker();
    if(!flatpickrDate || flatpickrDate == ''){
        return getExperienceBookingDateOrDefaultFromLocalStorage();
    }

    return flatpickrDate;
}

function populateSearchFilters() {

    if(isFilterExpired()){
        resetAllLocalStorage();
    }


    if($("#js-srch-date-range")){
        flatpickr("#js-srch-date-range", {
            mode: "range",
            altInput:true,
            altFormat: "j F",
            dateFormat: "Y-m-d",
            minDate: formatDate(new Date()),
            disableMobile: "true",
            // Hooks for syncing year dropdown
            onReady: syncYearDropdown,
            onChange: syncYearDropdown,
            onMonthChange: syncYearDropdown,
            onYearChange: syncYearDropdown,
        });
    }

    if($("#js-srch-exprience-date")){
        flatpickr("#js-srch-exprience-date", {
            mode: "single",
            altInput:true,
            altFormat: "j F",
            dateFormat: "Y-m-d",
            minDate: formatDate(new Date()),
            disableMobile: "true",
            // Hooks for syncing year dropdown
            onReady: syncYearDropdown,
            onChange: syncYearDropdown,
            onMonthChange: syncYearDropdown,
            onYearChange: syncYearDropdown,
        });
    }

    const params = new URLSearchParams(window.location.search);
    const country = params.get('Country');
    console.log("Country from URL params:", country)

    var flatpickrDate = document.querySelector('#js-srch-date-range');
    if(flatpickrDate)
    {
        if(flatpickrDate._flatpickr.selectedDates.length == 0){
            var dates = getBookingDatesFromStorageOrDefault();
            setDatesToBookingDatesDatepicker(dates.checkInDate, dates.checkOutDate);
            saveDatesToLocalStorage();
        }
    }

    var adultsDrop = document.querySelector("#guests-adults");
    var childrenDrop = document.querySelector("#guests-children");
    if(adultsDrop || childrenDrop)
    {
        var storageAdults = getStorageAdultsChildren();
        if(adultsDrop){
            adultsDrop.value = storageAdults.adults;
        }
        if(childrenDrop && storageAdults.children > 0){
           childrenDrop.value = storageAdults.children;
        }
        saveAdultChildrenToLocalStorage();
    }

    var searchTermBox = document.querySelector("#js-srch-hotels");
    if(searchTermBox){
        var searchTerm = country || getSearchTermFromLocalStorage();
        searchTermBox.value = searchTerm;
    }


    var adultFilterBox = document.querySelector("#adults-min");
    var childrenFilterBox  = document.querySelector("#child-min");
    if(adultFilterBox){
        var storageAdults = getStorageAdultsChildren();
        adultFilterBox.value = storageAdults.adults;
        childrenFilterBox.value = storageAdults.children;
    }

    
    var flatpickrExperienceDate = document.querySelector('#js-srch-exprience-date');
    if(flatpickrExperienceDate)
    {
        if(flatpickrExperienceDate._flatpickr.selectedDates.length == 0){
            var date = getExperienceBookingDateOrDefaultFromLocalStorage();
            setDatesToExperienceDatesDatepicker(date);
        }
    }

    var experienceFilter = getExperienceItemsFromLocalStorage();
    var experienceSearchBox = document.querySelector("#js-srch-experiences");
    if(experienceFilter)
    {
        if(experienceFilter.location && experienceSearchBox)
        {
            experienceSearchBox.value = experienceFilter.location;
        
        }

        if(experienceFilter.experienceType){
            var experienceTypeDDL = $("#experience-types-ddl");
            if(experienceTypeDDL){
                $(experienceTypeDDL).val(experienceFilter.experienceType);
            }
        }
    }
    
    if(country && experienceSearchBox)
    {
        experienceSearchBox.value = country;
    }

    saveExperienceItemsToLocalStorage();
}

/*Date Getters*/
function getFormattedDatesFromBookingDatePicker(){
    const fpInstance = document.querySelector('#js-srch-date-range');
    if (!fpInstance) {
      return null;
    }
  
    const parts = fpInstance.value.split(' to ');
    if (parts.length !== 2){
        return null;
    }
    
    const [checkInDate, checkOutDate] = parts;
  
    return {
      checkInDate: checkInDate,
      checkOutDate: checkOutDate
    };
}

function getFormattedDateFromExperienceDatePicker(){
    const fpInstance = document.querySelector('#js-srch-exprience-date');
    if (!fpInstance) {
      return null;
    }
  
    return fpInstance.value;
}

/*Date Setters*/
function setDatesToBookingDatesDatepicker(formattedCheckInDate, formattedCheckOutDate){
    var flatpickrDate = document.querySelector('#js-srch-date-range');
    if(flatpickrDate){
        var arry = [];
        arry.push(formatDateStringToDate(formattedCheckInDate));
        arry.push(formatDateStringToDate(formattedCheckOutDate));
        flatpickrDate._flatpickr.setDate(arry);
    }
}
function setDatesToExperienceDatesDatepicker(formattedBookingDate){
    var flatpickrDate = document.querySelector('#js-srch-exprience-date');
    if(flatpickrDate){
        flatpickrDate._flatpickr.setDate(formatDateStringToDate(formattedBookingDate));
    }
}

function saveDatesToLocalStorage(){
    var bookingDates = getFormattedDatesFromBookingDatePicker();
    setStorageItem('checkInOutDates', {
        checkInDate: bookingDates.checkInDate,
        checkOutDate: bookingDates.checkOutDate
    });
}

function saveFilterToLocalStorage(){
    saveDatesToLocalStorage();
    saveAdultChildrenToLocalStorage();
    saveSearchTermToLocalStorage();
}

function setFilterExpiry(hoursAhead = 2) {
    if(!isFilterExpired()){
        return;
    }
    const expiryTime = Date.now() + hoursAhead * 60 * 60 * 1000;
    localStorage.setItem('filterExpiry', expiryTime.toString());
}

/*function setFilterExpiry(minutesAhead = 1) {
    if(!isFilterExpired()){
        return;
    }
    const expiryTime = Date.now() + minutesAhead * 60 * 1000;
    localStorage.setItem('filterExpiry', expiryTime.toString());
}*/

function clearFilterExpiry(){
    localStorage.removeItem('filterExpiry');
}

function isFilterExpired() {
    const expiry = parseInt(localStorage.getItem('filterExpiry'), 10);

    // Expired or doesn't exist
    if (!expiry || Date.now() > expiry) {
        clearFilterExpiry();
        return true;
    }

    return false;
}

function saveExperienceItemsToLocalStorage(){
    setStorageItem('experienceFilters', {
        bookingDate: getFormattedDateFromExperienceDatePicker(),
        location: document.querySelector("#js-srch-experiences").value,
        experienceType: document.querySelector("#experience-types-ddl").value
    });
}

function getExperienceItemsFromLocalStorage(){
    return getStorageItem('experienceFilters');
}


function saveAdultChildrenToLocalStorage(){
    setStorageItem('adults', $('#guests-adults').val());
    setStorageItem('children', $('#guests-children').val());
}

function saveSearchTermToLocalStorage(){
    setStorageItem('searchTerm', $('#js-srch-hotels').val());
}

function getSearchTermFromLocalStorage()
{
    return getStorageItem('searchTerm');
}

function patchGuestBooking(bookingId, requestData) {
    console.log("Booking Patch Request Data:", requestData);

    $.ajax({
        url: "/api/booking/" + bookingId,
        method: "PATCH",
        contentType: "application/json",
        data: JSON.stringify(requestData),
        success: function (response) {
            console.log('successful patch', response);
        },
        error: function (xhr, status, error) {
            let errorMessage = "Failed to patch booking:" + xhr.status + " - " + xhr.responseText;
            $(".js-response-patch").text(errorMessage);
        }
    });
}

function updateAdultChildren(){
    var adultFilterBox = document.querySelector("#adults-min");
    var childrenFilterBox  = document.querySelector("#child-min");

    var adultsDrop = document.querySelector("#guests-adults");
    var childrenDrop = document.querySelector("#guests-children");
    if(adultsDrop || childrenDrop)
    {
        if(adultsDrop){
            adultsDrop.value = adultFilterBox.value;
        }
        if(childrenDrop){
             childrenDrop.value = childrenFilterBox.value;
        }
        saveAdultChildrenToLocalStorage();
    }
}


function initialiseFilterAndGet(){
    if(isHotelListingPage()){
        swapFilter('suites');
        populateSearchFilters();
        getAndSetListingFilterFields();
        getAllHotelAndSuites(true);
    }
    else{
        swapFilter('experiences');
        populateSearchFilters();
        getAndSetListingExperienceFilterFields();
        getAllExperiences();
    }
    loadMapContent();
    setupEnterInput();
}

function setupEnterInput(){
    $('#js-srch-hotels,#js-srch-experiences').on('keydown', function (e) {
        if (e.key === 'Enter' || e.which === 13) {
          $('#search-hotels').trigger('click');
        }
      });
}



function getPopularFilters(){
    let popFilters = [];

    let filterBoxes = $("#popular-filters li input");

    $(filterBoxes).each(function(index, element) {
        if($(element).is(":checked")){
            popFilters.push(parseInt($(element).val()));
        }
    });

    return popFilters;
}

function getMultiSelectedValues(selector){
    let popFilters = [];

    let filterBoxes = $(selector+" li input");

    $(filterBoxes).each(function(index, element) {
        if($(element).is(":checked")){
            popFilters.push($(element).val());
        }
    });

    return popFilters;
}

function getActiveElementIndex($elements, className) {
    let activeIndex = -1;
  
    $elements.each(function(index) {
      if ($(this).hasClass(className)) {
        activeIndex = index;
        return false; // stop once found
      }
    });
  
    return activeIndex;
  }

  $(document).on("click", ".left-btn", function (){
    toggleImage($(this),false);
}); 

$(document).on("click", ".right-btn", function (){
    toggleImage($(this),true);
}); 

function toggleImage(element, forward){
    var currentImgs = $(element).closest('.img-container').find('img');
    const totalImages = currentImgs.length;
    let currentIndex = getActiveElementIndex(currentImgs, 'active');
    currentIndex = forward ? (currentIndex > 0) ? currentIndex - 1 : totalImages - 1 : (currentIndex < totalImages - 1) ? currentIndex + 1 : 0;
    showImage(currentImgs,currentIndex);
}

function showImage(elements, index) {
    elements.removeClass('active');
    elements.eq(index).addClass('active');
}

function initTableDefault(){
    $('.w-table-default').each(function(){
        $(this).find('thead > tr > *').each(function(i){
            var txt = $(this).text();
            if (!txt) return;
            $(this).closest('.w-table-default')
            .find('tbody > tr > *:nth-child(' + (i+1) + ')')
            .prepend('<span class="w-mobile-only">' + txt + '</span>');
        });
    })
}

$(function(){
    initTableDefault();
});


$(".expansive-tab").on("click",function(){
    $(this).find(".expansive-box").toggleClass("active");
})

function setOrderBy()
{
    if(isHotelListingPage())
    {
        getAllHotelAndSuites();
    }
    else{
        getAllExperiences();
    }
}

$(".js-filter-select button").on("click",function()
{
    swapFilter($(this).data("filter-type"));
    if(isHotelListingPage() && isExperiencesFilterActive()){
        window.location.href = '/experiences';
    }
    else if(isExperienceListingPage() && isSuitesFilterActive()){
        window.location.href = '/suites'
    }
    else{
        loadMapContent();
        loadFeaturedContent();
    }
    
});

function swapFilter(data){
    var activeButton = $(".js-filter-select button[data-filter-type='"+data+"']");
    $(".js-filter-select button").addClass("btn-secondary").removeClass("btn-primary");
    $(activeButton).addClass("btn-primary").removeClass("btn-secondary");

    filterDivs(data);
}

function getFilterType(){
    var activeButton = $(".js-filter-select button.btn-primary");
    return $(activeButton).data("filter-type");
}

function isSuitesFilterActive(){
    var filterType = getFilterType();
    return filterType == "suites";
}
function isExperiencesFilterActive(){
    var filterType = getFilterType();
    return filterType == "experiences";
}

function loadMainFilter(){
    let filterBy = isExperienceListingPage() ? 'experiences' : 'suites';
    swapFilter(filterBy);
}

function filterDivs(typeToShow) {
    $('#hotel-search-menu .menu-item[data-filter-type]').each(function() {
      if ($(this).data('filter-type') === typeToShow) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }



  function loadFeaturedContent(){
        if($(".js-featured-button").length > 0){
            $(".js-featured-button").text("View More")
            $(".js-featured-button").attr("href", isExperiencesFilterActive() ? "/experiences" : "/suites")
        }

        if(isSuitesFilterActive())
        {
            getFeaturedHotels();
        }
        else{
            getFeaturedExperiences();
        }       
    }

    function loadMapContent()
    {
        if(isSuitesFilterActive())
        {
            getMapHotels();
        }
        else{
            getMapExperiences();
        }
    }

function resetAllLocalStorage(){
    localStorage.clear();
}

$("#search-hotels-clear").on("click",function(){
    setField("#js-srch-experiences", "");
    setField("#experience-types-ddl", "");
    var today = todayDate();
    setDatesToExperienceDatesDatepicker(formatDate(today))
    saveExperienceItemsToLocalStorage();
    setField("#js-srch-hotels", "");
    setField("#guests-adults", "1");
    setField("#guests-children", "0");
    setDatesToBookingDatesDatepicker(formatDate(defaultCheckInDate()), formatDate(defaultCheckOutDate()))
    saveFilterToLocalStorage();
    clearFilterExpiry();
    if(isHotelListingPage() || isExperienceListingPage()){
        clearAllFields();
    }
    else{
        location.reload();
    }
})

function updatePriceExperience(isAdult, incrementAmount = true){
    var target = isAdult ? "adults-min" : "child-min";
    if(incrementAmount)
    {
        increment(target);
    }
    else
    {
        decrement(target, isAdult ? 1 : 0);
    }
    
    var adults = parseInt($("#adults-min").val()) || 1;
    var children = parseInt($("#child-min").val()) || 0;
    priceExperience(adults, children);
}

function priceExperience(adults, children){
    const incrementAdult = priceIncrementAdult;
    const incrementChild = priceIncrementChild;
    const symbol = priceSymbol;
    const currency = priceCurrencyCode;

    var amount = formatCurrency((adults * incrementAdult) + (children * incrementChild),currency,symbol);

    $(".js-total-experience-price").html(amount);
    $("#total-experience-price").val(amount);
}

function formatCurrency(value, currencyCode = 'USD', symbol, decimals = 2) {
    const formattedNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value);
  
    return `${symbol}${formattedNumber} ${currencyCode}`;
  }

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function formatDateStringToDate(dateStr) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        console.error("Invalid date format. Expected 'YYYY-MM-DD'. Received:", dateStr);
        dateStr = formatDate(new Date(dateStr));
    }
  
    const [yearStr, monthStr, dayStr] = dateStr.split('-');
    return new Date(
      parseInt(yearStr, 10),
      parseInt(monthStr, 10) - 1,
      parseInt(dayStr, 10)
    );
  }


  function setupSliders(perpage = 1){
    Array.from(document.querySelectorAll('.slider')).forEach(function(el)
    {
        setupSplider(el,perpage);
    });
  }

  function setupTileSliders(){
    Array.from(document.querySelectorAll('.slider')).forEach(function(el)
    {
        setupTileSplider(el);
    });
  }

  function setupSplider(el, perpage = 1){
    if (typeof Splide == 'undefined'){
        return;
    }
            var normal = el.querySelector('.splide.normal');
            let bigSlider = null;
            if (normal)
            {
                bigSlider = new Splide(normal, {
                    type: 'fade',
                    heightRatio: 0.5,
                    pagination: false,
                    arrows: true,
                    cover: true,
                    lazyLoad: 'sequential',
                    preloadPages: 0,
                    padding: { left: '4rem', right: '4rem' }
                });
            }
            var thumbs = el.querySelector('.splide.thumbs');
            if (thumbs && normal) 
            {
                let thumbSlider = new Splide(thumbs, {
                    rewind: true,
                    fixedWidth: 100,
                    fixedHeight: 64,
                    isNavigation: true,
                    gap: '1rem',
                    focus: 'center',
                    pagination: false,
                    cover: true,
                    arrows: false,
                });
                bigSlider.sync(thumbSlider);
                bigSlider.mount();
                thumbSlider.mount();
            }
            else {
                bigSlider.mount();
            }
  }

  function setupTileSplider(el){
    if (typeof Splide == 'undefined'){
        return;
    }
    var normal = el.querySelector('.splide.normal');
    if(normal)
    {
        let bigSlider =  new Splide(normal, {
            type: 'fade',
            pagination: false,
            arrows: true,
            cover: true,
            perPage:1,
            lazyLoad: 'sequential',
            preloadPages: 0,
        });
        bigSlider.mount();
    }  
            
  }

  // Function to replace year input with a dropdown
    function syncYearDropdown(selectedDates, dateStr, instance) {
    setTimeout(() => {
        const container = instance.calendarContainer;
        let select = container.querySelector(".flatpickr-year-dropdown");

        // First-time setup: create dropdown
        if (!select) {
            const yearInput = container.querySelector(".cur-year");
            const numWrapper = yearInput.closest(".numInputWrapper");

            // Remove year arrows
            numWrapper.querySelector(".arrowUp")?.remove();
            numWrapper.querySelector(".arrowDown")?.remove();

            // Remove month arrows if desired
            container.querySelector(".flatpickr-prev-month")?.remove();
            container.querySelector(".flatpickr-next-month")?.remove();

            // Create dropdown
            select = document.createElement("select");
            select.className = "flatpickr-year-dropdown";

            // Build options once: current year + 5
            const now = new Date();
            const currentYear = now.getFullYear();
            for (let y = currentYear; y <= currentYear + 5; y++) {
                const opt = document.createElement("option");
                opt.value = y;
                opt.text = y;
                select.appendChild(opt);
            }

            // Replace input with dropdown
            yearInput.replaceWith(select);

            // Update Flatpickr year when dropdown changes
            select.addEventListener("change", (e) => {
                instance.currentYear = parseInt(e.target.value, 10);
                instance.redraw();
            });
        }

        // Update the selected value only
        select.value = instance.currentYear;

    }, 0); // ensure it runs after Flatpickr updates currentYear
}